/**
 * Extracts a Vidyard player UUID from a full share/watch URL or returns the value as-is when already a UUID.
 */
export function parseVidyardUuid(urlOrUuid: string): string | null {
  const trimmed = urlOrUuid.trim();
  if (!trimmed) return null;
  if (!trimmed.includes('/')) return trimmed;
  const match = trimmed.match(
    /(?:play\.vidyard\.com\/|share\.vidyard\.com\/watch\/)([A-Za-z0-9_-]+)/
  );
  return match?.[1] ?? null;
}
